export default "__VITE_ASSET__BACWr6Tj__"